/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-14 00:00:00
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@shopify/polaris';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { enableShopifyIntegration } from 'src/helpers/theme-setup-helper';
import { checkUserEnableShowAppVersionSwitching } from 'src/helpers/account-helper';
import {
  isInWhiteListTurbo,
  isInWhiteListTurboV2,
  LIST_TENANT_NOT_SHOW_MODAL
} from 'src/helpers/whitelist';
import { APP_VERSION_OLD_VERSION, APP_VERSION_TURBO } from 'src/constants/accounts';

import CustomModal from 'src/components/views/common/custom-modal';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { getShop } from 'src/helpers';

import BoostTurbo from 'assets/images/dashboard-v3/boost-turbo.png';
import BoostTurboV2 from 'assets/images/dashboard-v3/boost-turbo-v2.png';

type Props = {
  active: boolean,
  handleCancel: () => void,
  handleExplore: () => void
};

export const KEY_BOOST_TURBO_MODAL = 'already-close-modal-boost-turbo';

type ComposedProps = Props & WithI18nProps;
class BoostTurboModal extends Component<ComposedProps> {
  state = {
    active: false
  };

  componentDidMount() {
    try {
      const isAllowOpen = !localStorage.getItem(`${getShop()}-${KEY_BOOST_TURBO_MODAL}`);
      if (isAllowOpen) {
        setTimeout(() => {
          this.setState({
            active: true
          });
        }, 1500);
      }
    } catch (e) {
      console.log('error', e);
    }
  }

  handleClose = () => {
    localStorage.setItem(`${getShop()}-${KEY_BOOST_TURBO_MODAL}`, true);
    this.setState({
      active: false
    });
  };

  handleExplore = () => {
    this.handleClose();
    history.push(routes.appPreferences.view());
  };

  checkAllowedShowModalTurbo = () => {
    const { tenantApp } = this.props;
    const { appVersion } = tenantApp;
    const isEnableShopifyIntegration = enableShopifyIntegration(tenantApp);
    const enableAppVersionSwitching = checkUserEnableShowAppVersionSwitching(tenantApp);

    const initAppVersion = appVersion
      ? appVersion
      : isEnableShopifyIntegration
      ? APP_VERSION_TURBO
      : APP_VERSION_OLD_VERSION;

    try {
      const isInWhiteList =
        isInWhiteListTurbo(tenantApp.tenantId) || isInWhiteListTurboV2(tenantApp.tenantId);
      const isAllowOpenBoostTurboModal =
        !localStorage.getItem(`${getShop()}-${KEY_BOOST_TURBO_MODAL}`) &&
        initAppVersion === APP_VERSION_OLD_VERSION &&
        isInWhiteList &&
        enableAppVersionSwitching &&
        !LIST_TENANT_NOT_SHOW_MODAL.includes(tenantApp.tenantId);
      return isAllowOpenBoostTurboModal;
    } catch (e) {
      console.log('error', e);
    }
  };

  render() {
    const { active } = this.state;
    const { tenantId } = this.props;
    const isTurboV2 = isInWhiteListTurboV2(tenantId);
    const isAllowOpenBoostTurboModal = this.checkAllowedShowModalTurbo();

    if (!isAllowOpenBoostTurboModal) return <></>;

    return (
      <CustomModal
        id="modal-turbo"
        open={active}
        className="custom-modal custom-modal--turbo"
        clickBackdrop={this.handleClose}>
        <div className="modal-boost-turbo">
          <img src={isTurboV2 ? BoostTurboV2 : BoostTurbo} alt="Boost Turbo" />
          <div className="btn-blind" onClick={this.handleExplore} />
          <div className="closeBtn">
            <Button onClick={this.handleClose} icon={MobileCancelMajor} plain />
          </div>
        </div>
      </CustomModal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  tenantApp: _.get(state.oauth, 'tenantApp', {})
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(BoostTurboModal));
